import type { ReactNode } from 'react'
import BaseListOptions from './base-list-option'
import type { AsHeadlessType } from './common-list-option'
import type { DataInterface, ExtendedDataType, GroupDataInterface } from './editable-form-select'

interface BaseListProps<T extends ExtendedDataType> {
  data?: T[]
  value?: DataInterface<T>['id']
  getOptionDataAttribute?: (value?: string) => void
  groups?: GroupDataInterface[]
  optionIconRenderer?: (data?: T) => ReactNode | undefined
  as: AsHeadlessType
}

function BaseList<T extends ExtendedDataType>({
  data,
  value,
  getOptionDataAttribute,
  groups,
  optionIconRenderer,
  as,
}: BaseListProps<T>): ReactNode {
  return (
    <div className="customScroll max-h-60 w-full min-w-0 border-collapse overflow-x-hidden overflow-y-auto rounded-md border border-text-secondary/30 bg-background-secondary text-sm focus:outline-hidden">
      {groups ? (
        groups.map(group => (
          <BaseListOptions
            data={data}
            group={group}
            value={value}
            getOptionDataAttribute={getOptionDataAttribute}
            optionIconRenderer={optionIconRenderer}
            key={group.id}
            as={as}
          />
        ))
      ) : (
        <BaseListOptions
          data={data}
          value={value}
          getOptionDataAttribute={getOptionDataAttribute}
          optionIconRenderer={optionIconRenderer}
          as={as}
        />
      )}
    </div>
  )
}

export default BaseList
